import dayjs from 'dayjs';

export type EmailContentType = 'Meeting Notes' | 'Meeting Agenda' | 'Data Export';

export function buildMailtoUrl(recipient: string, subject: string, body: string): string {
  // Encode the recipient so a crafted address can't smuggle extra mailto fields or recipients
  // via '?', '&' or ','. '@' is restored afterwards for email-client compatibility.
  const encodedRecipient = encodeURIComponent(recipient).replace(/%40/g, '@');
  const encodedSubject = encodeURIComponent(subject);
  const encodedBody = encodeURIComponent(body);
  return `mailto:${encodedRecipient}?subject=${encodedSubject}&body=${encodedBody}`;
}

const TRUNCATION_SUFFIX = '\n\nView full content in Afternoon';
const DEFAULT_MAX_LENGTH = 1800;

export function truncateForMailto(content: string, maxLength: number = DEFAULT_MAX_LENGTH): string {
  if (content.length <= maxLength) {
    return content;
  }

  const truncationPoint = maxLength - TRUNCATION_SUFFIX.length;
  if (truncationPoint <= 0) {
    return TRUNCATION_SUFFIX.trim();
  }

  return content.slice(0, truncationPoint) + TRUNCATION_SUFFIX;
}

export function formatEmailSubject(type: EmailContentType, clientName: string, date: Date): string {
  const formattedDate = dayjs(date).format('DD MMM YYYY');
  return `${type} - ${clientName} - ${formattedDate}`;
}
